

















import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class CreatePurchaseOrder extends Vue {
  
  @Prop() public checkedOrderItems:Array<Common.SalesOrderItem>; 
  @Prop({ default: false}) public isBulkOrder:boolean; 
  @Prop() public checkedOrders:Array<Common.SalesOrder>;
  @Prop() public parentMainList:Components.ListView;
  @Prop() public salesOrderItems:Components.GrdVoucherItem;
  @Prop() public parent:any;
  @Prop() public isItemFlag:boolean;
  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;
  // 発注処理用プロパティ
  public cpoWorkflowId: number = 0;
  public cpoPic:string = null;
  public cpoSupplier: Common.Counterpart = null;
  public cpoDeliveryFlag: Common.DeliveryFlags = Common.DeliveryFlags.Stock;
  public cpoSupplierEnabled = true;
  public cpoAddExistPurchaseOrder = false;
  public cpoTargetOrders: Array<Common.SalesOrder>;

  public cpoPurchaseOrders: Array<Common.Order> = new Array(0);
  public htmlTips: string = "";

  public createSeparately: boolean = true;

  // 発注処理ダイアログの表示
  public mounted(){
    if(this.isBulkOrder==true){
      this.cpoTargetOrders = this.checkedOrders.filter(item=>(item.state >= Common.OrderStatus.SalesOrderItemsOperateWaiting) && (item.state < Common.OrderStatus.SalesOrderArrivalWaiting));
      if(this.cpoTargetOrders.length == 0){
        this.$api.modal.show('', '「出荷処理待ち」か「出荷処理中」の受注伝票を選択してください。', true, null);
        return;
      }
    }else{
      // ダイアログ表示前バリデーション
      if(this.checkedOrderItems.length == 0){
        this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
        return;
      }
      if(this.checkedOrderItems.filter(item=>item.backSalesOrderQuantity != 0).length == 0){
        this.$api.modal.show('', '受注残数量のある明細がないため、発注出来ません。', true, null);
        return;
      }
      // if(this.checkedOrderItems.filter(item=>item.isNoStock == true).length > 0){
      //   this.$api.modal.show('', '棚卸対象外商品は発注できません。', true, null);
      //   return;
      // }
      // ステータス変更にともない条件変更
      if(this.checkedOrderItems.filter(item=>item.state < Common.OrderItemStatus.SalesOrderUnallocated ).length > 0){
        this.$api.modal.show('', '受注一覧で受注確定がされた明細を選択して下さい。', true, null);
        return;
      }
      // 一括発注でない場合はダイアログ下部のtips設定
      this.htmlTips="<p class=cx_salesorder_dialog_tips>【業務処理＞一括発注処理】より、複数の受注をまとめて発注することができます。詳細は<a href='https://support.s-flow.net/ja/articles/6880885#h_2536219c47' target='_blank'>こちら</a></p>";
      // 納入区分の初期値設定
      if(this.checkedOrderItems.filter(item=>item.isNoStock == false).length == 0)
        this.cpoDeliveryFlag = Common.DeliveryFlags.Services;
      else
        this.cpoDeliveryFlag = Common.DeliveryFlags.Stock;
    }

    // プロパティの初期化
    this.cpoWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseOrder');
    this.onChangeWorkflow();
    this.cpoPic = this.$api.auth.userId;
    this.cpoSupplier = null;
    if(this.isBulkOrder==true){
      this.createSeparately = true;
      var query = new Common.CreatePuchaseOrderBulkCheckQuery();
      query.salesOrders = this.cpoTargetOrders;
      this.$api.execute(query).then(res => {
        // 発注先の活性状態制御
        this.cpoSupplierEnabled = res.hasNoSupplier;
        (this.$refs.createPurchaseOrderDialog as Components.ListDialog).showDialog();
        // すべて棚卸対象外の場合納入区分の初期値を「役務等」に
        if (!res.hasAnyStock) this.cpoDeliveryFlag = Common.DeliveryFlags.Services;
      });
    }
    else{
      this.cpoSupplierEnabled = this.checkedOrderItems.filter(obj => obj.supplier == null).length != 0;
      // ダイアログの表示
      (this.$refs.createPurchaseOrderDialog as Components.ListDialog).showDialog();
    }
  }

  // 発注処理の実行
  public SubmitCreatePurchaseOrder(items:any[], index:number) {
    // クエリの設定
    var query = new Common.CreatePuchaseOrderQuery();
    query.isBulkOrder = this.isBulkOrder;
    query.salesOrders = this.cpoTargetOrders;
    query.salesOrderItems = this.checkedOrderItems;
    query.pic = this.cpoPic;
    query.counterpart = this.cpoSupplier;
    query.deliveryFlag = this.cpoDeliveryFlag;
    query.workflowId = this.cpoWorkflowId;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.addExistPurchaseOrder = this.cpoAddExistPurchaseOrder;
    query.createSeparately = this.createSeparately;
    (this.$refs.createPurchaseOrderDialog as Components.ListDialog).closeDialog();
    // (this.$refs.createPurchaseOrderDialog as Components.ListDialog).show = false;   // ここでクローズメソッド呼び出す感じで
    return this.$api.execute(query,true).then(res => {
      // 画面を更新
      if(this.isItemFlag || this.checkedOrders){
        this.parentMainList.reload().then(()=>{if(this.salesOrderItems)this.salesOrderItems.onVoucherNoChanged();});
      }
      else
      {
        this.$api.find('Order', [((this.parentMainList as Components.ListView).selected as Common.SalesOrder).orderNo]).then(res2 => 
          this.parent.onWorkflow(this.parentMainList.currentId,res2));
      }
      //トライアル中はロードマップを更新
      if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();      
      var orders = res as Common.Order[];
      var links = orders.map(order=>new Common.ModalLink(order.orderNo,String.format('/purchase/PurchaseOrder?orderNo={0}',order.orderNo)));
      var dialogMessage = '以下の発注伝票が作成・更新されました。';
      if(this.$api.tenantSettings.noCheckPriceRequired == false && orders.filter(order => order.hasNoPriceItem == true).length > 0) dialogMessage += '\r\n※単価の設定がされていない明細があります。';
      if(orders.length == 1){
        this.$api.modal.show('処理結果',dialogMessage,false,()=>{
          var url = String.format('/purchase/PurchaseOrder?orderNo={0}',orders[0].orderNo);
          if (url){ this.$router.push(url);}
        },links,'伝票に移動する','閉じる');
      }else{
        this.$api.modal.show('処理結果',dialogMessage,true,null,links,'閉じる');
      }

// ***** 一括発注処理の成功確認 *****
if(this.checkedOrders){
let deliveryFalgText = this.$api.formatter.formatByList(this.cpoDeliveryFlag,'deliveryFlagsHasCommodity');
this.$api.issueGA4trackevent(this.$route.path,String.format('【受注一覧】一括発注処理・成功 [納入区分：{0}]', deliveryFalgText));
}

      return true;
    }).catch(()=>{ return false;});      
  }
  public onChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("発注保存");
    if(this.cpoWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('purchaseOrder', this.cpoWorkflowId, Common.OrderStatus.PurchaseOrderSaving);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
  @Watch('createSeparately')  
  public onChangeCreateSeparately(){
    if(this.createSeparately)this.cpoAddExistPurchaseOrder = false;
  }
}
